module.exports = __webpack_public_path__ + "img/totally-radio-60s.4656e220.png";